const shopSlider = document.querySelectorAll('[data-slider="shop-module__slider"]');

const shopSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  speed: 800,
};

shopSlider.forEach((el) => {
  new Swiper(el, shopSliderOptions);
});
